import { FormGroup } from "@angular/forms";
import { HowOwned } from "./states/loan/step-four.model";
import { parseCurrency } from "../form-control-formatters/currency.formatter";

type Asset = {
    uuid?: string;
    name: string;
    value?: number;
    how_owned?: HowOwned;
    secures?: boolean;
    amount_owed?: number;
    monthly_payment?: number;
    address?: string;
    real_estate_type_uuid?: string;
    payable_to?: string;
    description?: string;
}

export default Asset;

const hasNumber = (n: unknown): boolean =>
    n != null && n !== '' && !Number.isNaN(Number(n));

export const isAssetEmpty = (a?: Asset): boolean => {
    if (!a) return true;
    return !(
        hasNumber(a.value) ||
        !!a.how_owned ||
        !!a.secures ||
        hasNumber(a.amount_owed) ||
        hasNumber(a.monthly_payment) ||
        !!a.address ||
        !!a.real_estate_type_uuid ||
        !!a.payable_to ||
        !!a.description
    );
};

export const assetFromFormGroup = (control: FormGroup, name: string, uuid?: string): Asset => {
    return {
        uuid,
        name,
        address: control.get('address')!.value === '' ? null : control.get('address')!.value,
        amount_owed: control.get('amountOwed')!.value === '' ? null! : parseCurrency(control.get('amountOwed')!.value),
        description: control.get('description')!.value === '' ? null : control.get('description')!.value,
        how_owned: control.get('howOwned')!.value === '' ? null : control.get('howOwned')!.value,
        monthly_payment: control.get('monthlyPayment')!.value === '' ? null! : parseCurrency(control.get('monthlyPayment')!.value),
        payable_to: control.get('payableTo')!.value === '' ? null : control.get('payableTo')!.value,
        real_estate_type_uuid: control.get('realEstateType')!.value === '' ? null : control.get('realEstateType')!.value,
        secures: control.get('secures')!.value === false ? false : true,
        value: control.get('value')!.value === '' ? null! : parseCurrency(control.get('value')!.value)
    }
}
